/** In-memory access JWT. Refresh tokens stay in the HttpOnly cookie. */

let accessToken = null;

export function getAccessToken() {
  return accessToken;
}

export function setAccessToken(token) {
  accessToken = token || null;
}

export function clearAccessToken() {
  accessToken = null;
}

export function clearLegacyTokenStorage() {
  const keys = ['access_token', 'refresh_token', 'is_staff', 'username', 'groups', 'csrfToken'];
  keys.forEach((key) => {
    try {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (_) {
      /* private mode */
    }
  });
}
